// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import * as React from 'react';
import { render } from 'react-dom';
import { Store, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import searchReduce from './reducers/searchReduce';
import SearchConnect from './searchPage';
import { loadState, saveState } from './storage/localStorage';
import { loadStateFromStorage } from './actions/app-actions';
import { ISearchResultData } from './objects/iSearchResultData';
import { ISearchFacet } from './objects/iSearchFacet';
import throttle = require('lodash/throttle');
import { SearchState } from './reducers/searchReduce';
import 'url-search-params-polyfill';
let container = document.getElementById('app-container');
let persistedState = loadState();

let initialState: SearchState
    = {
        isLoading: false,
        displayStart: 0,
        displayLength: 10,
        searchResultData: {
            sEcho: "",
            iTotalRecords: 0,
            iTotalDisplayRecords: 0,
            aaData: [],
            facets: [],
            suggestion: "",
        },
        searchFacets: [],
        showSearchBar: container.getAttribute('data-showSearchBar') == 'true',
        defaultCatalogNode: container.getAttribute('data-defaultCatalogNode'),
        currentCountry: container.getAttribute('data-currentCountry')
    }

let store = createStore(
    searchReduce,
    initialState,
    applyMiddleware(
        thunkMiddleware
    )
);

let params = new URLSearchParams(location.search);
let keywordValue = params.get('q');
if (persistedState != undefined && persistedState.url == (location.pathname + keywordValue)) // Don't reload if switching browse pages or query
    store.dispatch(loadStateFromStorage(persistedState));

store.subscribe(throttle(() => {
    saveState({
        searchFacets: store.getState().searchFacets,
        displayStart: store.getState().displayStart,
        displayLength: store.getState().displayLength,
		url: (location.pathname + keywordValue)
    });
}, 1000));

render(
    <Provider store={store}>
        <SearchConnect />
    </Provider>,
    document.getElementById('app-container')
) 